import api from './axios';

export const stateAssociationAPI = {
  register: async (formData) => {
    const response = await api.post('/state-associations/register', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  login: async (credentials) => {
    const response = await api.post('/state-associations/login', credentials);
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get('/state-associations/profile');
    return response.data;
  },

  forgotPassword: async (data) => {
    const response = await api.post('/state-associations/forgot-password', data);
    return response.data;
  },

  verifyPasswordResetOTP: async (data) => {
    const response = await api.post('/state-associations/verify-password-reset-otp', data);
    return response.data;
  },

  resetPassword: async (data) => {
    const response = await api.post('/state-associations/reset-password', data);
    return response.data;
  },

  sendVerificationOTP: async (email) => {
    const response = await api.post('/state-associations/send-verification-otp', { email });
    return response.data;
  },

  verifyOTP: async (data) => {
    const response = await api.post('/state-associations/verify-otp', data);
    return response.data;
  },

  // New Event Application APIs
  getAssignedEvents: async (filters = {}) => {
    const response = await api.get('/state-associations/athlete-events', { params: filters });
    return response.data;
  },

  downloadEventTemplate: async (eventId) => {
    const response = await api.get(`/state-associations/athlete-events/${eventId}/download-template`);
    return response.data;
  },

  uploadEventApplication: async (eventId, file) => {
    const formData = new FormData();
    formData.append('applicationFile', file);
    
    const response = await api.post(
      `/state-associations/athlete-events/${eventId}/upload-application`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  getEventApplication: async (eventId) => {
    const response = await api.get(`/state-associations/athlete-events/${eventId}/application`);
    return response.data;
  },

  getMyApplications: async (filters = {}) => {
    const response = await api.get('/state-associations/my-applications', { params: filters });
    return response.data;
  },

  // Payment APIs
  getApplicationPaymentDetails: async (applicationId) => {
    const response = await api.get(`/state-associations/applications/${applicationId}/payment`);
    return response.data;
  },
};
